// Changing the shared auth constant can break login syncing since it's used as the cookie's key
export const SHARED_AUTH_ENGOO = 'SHARED_AUTH_ENGOO';
// Shared state between replace and engoo. This is kept separate from auth to avoid
// resetting the auth information anytime the shared state is updated.
export const SHARED_STATE_REPLACE = 'SHARED_STATE_REPLACE';

// This cookie will be present if the user is logged in via dmm
export const DMM_AUTH_COOKIE = 'login_session_id';
export const DMM_COOKIE_DOMAIN = 'dmm.com';
